module.exports = __webpack_public_path__ + "img/l4.39d4f9ca.jpg";